import e from "./_baseProperty.js";
import o from "./_basePropertyDeep.js";
import t from "./_isKey.js";
import p from "./_toKey.js";
var y = e, m = o, i = t, s = p;
function a(r) {
  return i(r) ? y(s(r)) : m(r);
}
var P = a;
export {
  P as default
};
//# sourceMappingURL=property.js.map
